/**
 * One place where every trade sketch reads and writes device storage.
 *
 * All sketches live on the phone — nothing here touches the network, so a
 * drawing made in a mechanical room with no signal is saved the same way as
 * one made in the truck.
 */
import type { SavedSketch } from "./index";

export function readJson<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : fallback;
  } catch {
    return fallback;
  }
}

export function writeJson(key: string, value: unknown) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* storage full — the drawing stays in memory for this session */
  }
}

/** `tt-sketch-duct` -> `tt-sketch-duct-saves` */
export const savesKeyFor = (storageKey: string) => `${storageKey}-saves`;
/** `tt-sketch-duct` -> `tt-sketch-duct-autosave` */
export const autoKeyFor = (storageKey: string) => `${storageKey}-autosave`;

export function loadSaves(storageKey: string): SavedSketch[] {
  const list = readJson<SavedSketch[]>(savesKeyFor(storageKey), []);
  return Array.isArray(list) ? list : [];
}

export function persistSaves(storageKey: string, list: SavedSketch[]) {
  writeJson(savesKeyFor(storageKey), list.slice(0, 60));
}
